/**
 * Entrada host-aware: app.* → Clinical; care.* → Care (mismo bundle, layouts separados).
 */
import { initSentryClient } from '../sentry.client.config';

initSentryClient();

import { applyHostDocumentBranding } from './platform/applyHostDocumentBranding';
import { resolveHostApp } from './platform/resolveHostApp';

const appId = resolveHostApp();
applyHostDocumentBranding(appId);

if (appId === 'care') {
  void import('./apps/care/bootstrap').then(({ mountCareApp }) => {
    mountCareApp();
  });
} else {
  void import('./apps/clinical/bootstrap').then(({ mountClinicalApp }) => {
    mountClinicalApp();
  });
}
